"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuthenticationActionTypes;
(function (AuthenticationActionTypes) {
    AuthenticationActionTypes["Authenticate"] = "[Authentication Actions] Authenticate";
    AuthenticationActionTypes["AuthenticateIfNecessary"] = "[Authentication Actions] Authenticate If Necessary";
    AuthenticationActionTypes["AuthenticationSuccess"] = "[Authentication Actions] Authentication Success";
    AuthenticationActionTypes["AuthenticationError"] = "[Authentication Actions] Authentication Error";
})(AuthenticationActionTypes = exports.AuthenticationActionTypes || (exports.AuthenticationActionTypes = {}));
//# sourceMappingURL=authentication-action-types.enum.js.map